const STORAGE_KEY = "a1_guest_orders";
const CUSTOMER_KEY = "a1_guest_customer";
const CART_KEY = "a1_rugs_guest_cart";

function readJson(key, fallback) {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
}

export function saveGuestOrder(orderResponse, cartItems = []) {
  if (!orderResponse?.order_number) return null;

  const customer = readJson(CUSTOMER_KEY, {});
  const storedCart = Array.isArray(cartItems) && cartItems.length
    ? cartItems
    : readJson(CART_KEY, []);

  const items = storedCart.map((item) => ({
    product: item.product ?? item.product_id,
    product_name: item.product_name ?? item.product?.name ?? item.name ?? "Rug",
    product_image: item.product_image ?? item.product?.image ?? item.product?.sub_images?.[0]?.image ?? item.image ?? null,
    size: item.size ?? {
      id: item.size_id,
      length_cm: item.length_cm,
      width_cm: item.width_cm,
      length_ft: item.length_ft,
      width_ft: item.width_ft,
      price: item.product_price ?? item.price,
      discount_price: item.discount_price,
    },
    quantity: Number(item.quantity || 1),
    price: Number(item.price ?? item.product_price ?? item.total_price ?? 0),
    total_price: Number(item.total_price ?? item.price ?? item.product_price ?? 0),
  }));

  const order = {
    id: orderResponse.order_id ?? orderResponse.id ?? orderResponse.order_number,
    order_number: orderResponse.order_number,
    status: orderResponse.status || "paid",
    total_amount: orderResponse.total_amount ?? orderResponse.total ?? 0,
    payment_method: orderResponse.payment_method || "stripe",
    stripe_session_id: orderResponse.stripe_session_id || null,
    paypal_order_id: orderResponse.paypal_order_id || null,
    customer_name: customer.customer_name || "",
    customer_email: customer.customer_email || "",
    customer_phone: customer.customer_phone || "",
    shipping_address: customer.shipping_address || "",
    shipping_city: customer.shipping_city || "",
    shipping_state: customer.shipping_state || "",
    shipping_postal_code: customer.shipping_postal_code || "",
    shipping_country: customer.shipping_country || "",
    created_at: new Date().toISOString(),
    items,
    guest: true,
  };

  const existing = readJson(STORAGE_KEY, []);
  const orders = Array.isArray(existing) ? existing : [];
  const next = [order, ...orders.filter((item) => item?.order_number !== order.order_number)];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return order;
}

export function getGuestOrders() {
  const orders = readJson(STORAGE_KEY, []);
  return Array.isArray(orders) ? orders : [];
}

export function getGuestOrder(orderNumber) {
  return getGuestOrders().find(
    (order) => String(order?.order_number) === String(orderNumber)
  ) || null;
}
